export default __webpack_public_path__ + "static/media/ecommerce-icon.8c7a83a3.png";